<template>
  <el-popover
    popper-class="voice-room-emoji-dialog"
    placement="right"
    width="386"
    trigger="click"
    v-model="emojiDialogVisible"
  >
    <ul>
      <li
        class="item"
        v-for="item of emojiList"
        :key="item.name"
        @click="sendMessage(item)"
      >
        <img class="icon" :src="item.imageUrlList[0]" alt="" />
        <span>{{ item.name }}</span>
      </li>
    </ul>

    <img
      class="icon-button"
      src="../images/voice_room_emoticon.png"
      alt=""
      slot="reference"
    />
  </el-popover>
</template>
<script>
import { getEmojiList } from '@/api/voice-room';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import { ChatMessage } from '@/components/VoiceRoom/chatProvider';
import { EmojiMessage } from '@/components/VoiceRoom/message';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
export default {
  name: 'EmojiDialog',
  props: {},
  data() {
    return {
      emojiList: [],
      emojiDialogVisible: false
    };
  },
  watch: {},
  computed: {
    userInfo() {
      return CurrentUserProvider.userInfo;
    },
    uuid() {
      return this.userInfo.uuid;
    },
    nickName() {
      return this.userInfo.nickname;
    },
    level() {
      return this.userInfo.level;
    },
    avatar() {
      return this.userInfo.avatarUrl;
    },
    seatIndex() {
      return CurrentUserProvider.seatInfo && CurrentUserProvider.seatInfo.index
        ? CurrentUserProvider.seatInfo.index
        : 0;
    }
  },
  created() {
    this.getEmojiList();
  },
  methods: {
    async getEmojiList() {
      const { data } = await getEmojiList();
      if (data) {
        this.emojiList = data;
      }
    },
    async sendMessage(item) {
      const emojiMessage = new EmojiMessage(
        this.uuid,
        this.nickName,
        this.avatar,
        item.name,
        this.seatIndex
      );
      await VoiceRoomIM.sendMessage(JSON.parse(JSON.stringify(emojiMessage)));
      const newMessage = new ChatMessage({
        action: 'emojiReceive',
        userId: this.uuid,
        nickName: this.nickname,
        message: '',
        ...emojiMessage.data.message
      });
      VoiceRoomIM.addNewMessage(newMessage);
      this.emojiDialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.icon-button {
  width: 26px;
  height: 26px;
}
ul {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.item {
  display: flex;
  flex-direction: column;
  width: 70px;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  margin: 10px;
  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.1);
  }
  .icon {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
}
</style>
<style>
.voice-room-emoji-dialog {
  /* padding: 0 !important;
  border: none; */
}
</style>
